import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, take, filter, switchMap } from 'rxjs';
import { environment } from '@environments/environment';
import { Authentication } from '@core/models';
import { IResponseObjectSuccess } from '@core/interfaces';
import { Store } from '@ngrx/store';
import { AppState } from '@store/reducers';
import { selectStore } from '@store/selectors';
import { Store as StoreModel } from '@core/models';

@Injectable({
	providedIn: 'root',
})
export class NotificationService {
	store$: Observable<StoreModel | null>;

	constructor(
		private http: HttpClient,
		private store: Store<AppState>
	) {
		this.store$ = this.store.select(selectStore);
	}

	subcribeNotification(token: string): Observable<IResponseObjectSuccess<Authentication>> {
		return this.store$.pipe(
			take(1),
			filter(store => !!store),
			switchMap(store => {
				return this.http.post<IResponseObjectSuccess<Authentication>>(
					`${environment.microNotificaciones}/notificaciones/tema/suscribir`,
					{
						token,
						topics: [store.idLocal],
						tiendaId: store.idLocal,
						deviceToken: token,
					},
					{
						headers: {
							authorization: store?.apiKey as string,
						},
					}
				);
			})
		);
	}
}
